export { default } from '@shikijs/langs/vb'
